import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    // Modal states
    showAddDeviceModal: false,
    showEditDeviceModal: false,
    showRemoveConfirmModal: false,
    showRemoveSuccessModal: false,
    showBulkRemoveConfirmModal: false,
    showBulkRemoveSuccessModal: false,
    showAssignModal: false,
    showDeviceDetailsModal: false,
    
    // Dropdown states
    showFilterDropdown: false,
    showProfileDropdown: false,
    activeDropdown: null,
    
    // Sidebar state
    showMobileSidebar: false,
    
    // Current device/member being edited
    currentDevice: null,
    currentMember: null,
    
    // Toast notifications
    toast: {
      show: false,
      message: '',
      type: 'success', // success, error, info, warning
    },
  },
  reducers: {
    // Modal actions
    openAddDeviceModal: (state) => {
      state.showAddDeviceModal = true;
    },
    closeAddDeviceModal: (state) => {
      state.showAddDeviceModal = false;
    },
    openEditDeviceModal: (state, action) => {
      state.showEditDeviceModal = true;
      state.currentDevice = action.payload;
    },
    closeEditDeviceModal: (state) => {
      state.showEditDeviceModal = false;
      state.currentDevice = null;
    },
    openRemoveConfirmModal: (state, action) => {
      state.showRemoveConfirmModal = true;
      state.currentDevice = action.payload;
    },
    closeRemoveConfirmModal: (state) => {
      state.showRemoveConfirmModal = false;
      state.currentDevice = null;
    },
    openRemoveSuccessModal: (state) => {
      state.showRemoveSuccessModal = true;
    },
    closeRemoveSuccessModal: (state) => {
      state.showRemoveSuccessModal = false;
      state.currentDevice = null;
    },
    openBulkRemoveConfirmModal: (state) => {
      state.showBulkRemoveConfirmModal = true;
    },
    closeBulkRemoveConfirmModal: (state) => {
      state.showBulkRemoveConfirmModal = false;
    },
    openBulkRemoveSuccessModal: (state) => {
      state.showBulkRemoveSuccessModal = true;
    },
    closeBulkRemoveSuccessModal: (state) => {
      state.showBulkRemoveSuccessModal = false;
    },
    openAssignModal: (state, action) => {
      state.showAssignModal = true;
      state.currentDevice = action.payload;
    },
    closeAssignModal: (state) => {
      state.showAssignModal = false;
      state.currentDevice = null;
    },
    openDeviceDetailsModal: (state, action) => {
      state.showDeviceDetailsModal = true;
      state.currentDevice = action.payload;
    },
    closeDeviceDetailsModal: (state) => {
      state.showDeviceDetailsModal = false;
      state.currentDevice = null;
    },
    
    // Dropdown actions
    toggleFilterDropdown: (state) => {
      state.showFilterDropdown = !state.showFilterDropdown;
    },
    closeFilterDropdown: (state) => {
      state.showFilterDropdown = false;
    },
    toggleProfileDropdown: (state) => {
      state.showProfileDropdown = !state.showProfileDropdown;
    },
    closeProfileDropdown: (state) => {
      state.showProfileDropdown = false;
    },
    setActiveDropdown: (state, action) => {
      state.activeDropdown = action.payload;
    },
    
    // Sidebar actions
    toggleMobileSidebar: (state) => {
      state.showMobileSidebar = !state.showMobileSidebar;
    },
    closeMobileSidebar: (state) => {
      state.showMobileSidebar = false;
    },
    
    // Toast actions
    showToast: (state, action) => {
      state.toast = {
        show: true,
        message: action.payload.message,
        type: action.payload.type || 'success',
      };
    },
    hideToast: (state) => {
      state.toast.show = false;
    },
  },
});

export const {
  openAddDeviceModal,
  closeAddDeviceModal,
  openEditDeviceModal,
  closeEditDeviceModal,
  openRemoveConfirmModal,
  closeRemoveConfirmModal,
  openRemoveSuccessModal,
  closeRemoveSuccessModal,
  openBulkRemoveConfirmModal,
  closeBulkRemoveConfirmModal,
  openBulkRemoveSuccessModal,
  closeBulkRemoveSuccessModal,
  openAssignModal,
  closeAssignModal,
  openDeviceDetailsModal,
  closeDeviceDetailsModal,
  toggleFilterDropdown,
  closeFilterDropdown,
  toggleProfileDropdown,
  closeProfileDropdown,
  setActiveDropdown,
  toggleMobileSidebar,
  closeMobileSidebar,
  showToast,
  hideToast,
} = uiSlice.actions;

export default uiSlice.reducer;
